import styled from 'styled-components'
import { colorTheme } from '../../../../../style/theme/colorTheme'
import { theme } from '../../../../../style/theme'

export const KeyboardWrap = styled.div`
	font-size: 1rem;
	border-radius: .75em;
	border: 2px solid  ${colorTheme.beeperKeyboard.border};
	background: ${colorTheme.beeperKeyboard.background};
	margin-bottom: 1.88em;

	@media screen and (max-width: ${theme.point720}) {
		padding: 1.25em 0.94em;
	}
`
KeyboardWrap.displayName = 'KeyboardWrap'

export const KeyboardContent = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 7.5em);
	align-items: center;
	gap: 1.88em;
	padding: 1.25em;
	justify-content: center;
	align-content: flex-start;
	align-self: stretch;

	@media screen and (max-width: ${theme.point820}) {
		grid-template-columns: repeat(3, 7.2em);
		gap: 1.25em;
	}
	@media screen and (max-width: ${theme.point720}) {
		grid-template-columns: repeat(3, minmax(5.4em, 6.25em));
		gap: 1.25em;
	}
`
KeyboardContent.displayName = 'KeyboardContent'

export const Key = styled.button`
	font-size: 1rem;
	display: flex;
	height: 5.63em;
	justify-content: center;
	align-items: center;
	gap: 15px;
	border-radius: .75em;
	border-width: 2px;
	border-style: solid;
	background: ${colorTheme.beeperKeyboard.key.background};
	user-select: none;
	cursor: pointer;
	transition: all 0.2s ease 0s;

	&.number {
		border-color: ${colorTheme.beeperKeyboard.key.border};
	}

	&.clear {
		border-color: ${colorTheme.beeperKeyboard.key.secondary.border};
		grid-column: 1 / 2;
		grid-row: 4;
	}

	&.delete {
		border-color: ${colorTheme.beeperKeyboard.key.secondary.border};

		> svg {
			width: 50px;
			height: 38px;
			fill: ${colorTheme.beeperKeyboard.key.secondary.icon};
			flex-shrink: 0;
		}
	}

	&:hover {
		&.number {
			box-shadow: 0 0 0 2px ${colorTheme.beeperKeyboard.key.border},
			0px 4px 4px 0px ${colorTheme.beeperKeyboard.key.shadow};
		}

		&.clear, &.delete   {
			box-shadow: 0 0 0 2px ${colorTheme.beeperKeyboard.key.secondary.border},
			0px 4px 4px 0px ${colorTheme.beeperKeyboard.key.shadow};
		}
	}
`
Key.displayName = 'Key'

export const KeyText = styled.div`
	text-align: center;
	font-family: ${theme.fontRoboto};
	font-weight: 500;
	font-style: normal;
	line-height: normal;

	&.number {
		color: ${colorTheme.beeperKeyboard.key.text};
		font-size: 2.5em;
		text-transform: uppercase;
	}

	&.clear {
		color: ${colorTheme.beeperKeyboard.key.secondary.text};
		font-size: 1.88em;
	}
`
KeyText.displayName = 'KeyText'
